<h5>Arquivos enviados (lotes)</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto" *ngIf="textoBotaoCadastro">
        <button class="btn btn-primary" type="button" [routerLink]="routerLinkCadastro" placement="bottom"
          ngbTooltip="Selecione esta opção para cadastrar uma nova transação" [disabled]="!podeEnviarLote">
          <i class="fa fa-file-signature"></i>
          {{textoBotaoCadastro}}
        </button>
      </div>
      <div class="col-auto" *ngIf="textoBotaoEnvio">
        <button class="btn btn-primary" type="button" [routerLink]="routerLinkEnvioLote" placement="bottom"
          ngbTooltip="Selecione esta opção para enviar lotes de transações" [disabled]="!podeEnviarLote"><i
            class="fa fa-upload"></i>
          {{textoBotaoEnvio}}
        </button>
      </div>
      <div class="col-auto" *ngIf="textoBotaoEnvio2">
        <button class="btn btn-primary" type="button" [routerLink]="routerLinkEnvioLote2" placement="bottom"
          ngbTooltip="Selecione esta opção para enviar lotes de transações" [disabled]="!podeEnviarLote"><i
            class="fa fa-upload"></i>
          {{textoBotaoEnvio2}}
        </button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" [disabled]="!podePesquisar()" class="btn btn-success"
          (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)">Pesquisar</button>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="podeEscolherAgente" id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId"
          formControlName="agenteFinanceiro">
          <option [ngValue]="undefined" [selected]="true">Todos</option>
          <option *ngFor="let agente of agentesFinanceiros">{{ agente.nome }}</option>
        </select>
        <select *ngIf="!podeEscolherAgente" disabled id="agenteFinanceiro" class="form-select"
          [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <ng-container *ngFor="let agente of agentesFinanceiros">
            <option selected *ngIf="agente?.cnpj == cnpjUsuario">{{ agente.nome }}</option>
          </ng-container>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="statusProtocolo">Status do arquivo: </label>
        <select id="statusProtocolo" class="form-select" formControlName="statusProtocolo">
          <option [selected]="true">Todos</option>
          <option *ngFor="let status of valoresStatusProtocolo">{{ status.label }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="idSolicitacaoApiExt">Id Solicitação API Externa:</label>
        <input type="text" bnMask="INTEIRO" class="form-control" name="idSolicitacaoApiExt" formControlName="idSolicitacaoApiExt">
      </div>
    </div>
    <div class="row">
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioInicial">Data de envio inicial:</label>
        <bn-datepicker name="dataEnvioInicial" idInput="dataEnvioInicial" formControlName="dataEnvioInicial">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioFinal">Data de envio final:</label>
        <bn-datepicker name="dataEnvioFinal" idInput="dataEnvioFinal" formControlName="dataEnvioFinal">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3" *ngIf="incluirCampoJanelaEnvio">
        <label class="form-label" for="nomeJanela">Janela de envio: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Nome da janela de envio em formato Mês/Ano (MM/AAAA)"></i></label>
        <input type="text" bnMask="MESANO" class="form-control" name="nomeJanela" formControlName="nomeJanelaEnvio" />
      </div>
      <div class="bn-form-group col-md-3" *ngIf="mostrarCampoModoEnvio">
        <label class="form-label" for="modoEnvio">Modo de envio:</label>
        <select id="modoEnvio" class="form-select" formControlName="modoEnvio">
          <option [selected]="true">Todos</option>
          <option>Efetivo</option>
          <option>Apenas validação</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3" *ngIf="exibirComboTipoArquivo">
        <label class="form-label" for="tipoProtocolo">Tipo do arquivo:</label>
        <select id="tipoProtocolo" class="form-select" formControlName="tipoProtocolo">
          <option value="null">Todos</option>
          <option [ngValue]="tipoProtocolo.codigo" *ngFor="let tipoProtocolo of tiposProtocolo ">
            {{tipoProtocolo.descricao}}</option>
        </select>
      </div>
    </div>
  </form>
</div>

<bn-loading-overlay></bn-loading-overlay>

<app-protocolo-listagem *ngIf="pesquisado" [hidden]="esconderPesquisa" [cnpjAgente]="cnpjSelecionado" [protocolos]="protocolos"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem" (aoMudarPagina)="mudancaPagina($event)"
  [exibirComboTipoArquivo]="exibirComboTipoArquivo" (aposExcluirProtocolo)="aposExcluirProtocolo()"
  [formatoArquivo]="formatoArquivo" >
</app-protocolo-listagem>
